import { render, staticRenderFns } from "./SolicitudesPendientesLista.html?vue&type=template&id=2c3fecc0&external"
import script from "./SolicitudesPendientesLista.vue?vue&type=script&lang=js"
export * from "./SolicitudesPendientesLista.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesPendientesLista.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports